// import { createSlice } from "@reduxjs/toolkit";

import { createSlice } from "@reduxjs/toolkit";
import { loadAllNotifications } from "../commonThunks/notificationsThunk";

// const notificationSlice = createSlice({
//   name: "notifications",
//   initialState: {
//     count: 0,
//     list: [], // optional if you also want to store fetched items
//   },
//   reducers: {
//     setNotificationCount: (state, action) => {
//       state.count = action.payload;
//     },
//     setNotifications: (state, action) => {
//       state.list = action.payload;
//     },
//     setNotificationList: (state, action) => {
//     state.list = action.payload;
//     },
//     setActivityList: (state, action) => {
//     state.activities = action.payload;
//     },

//   },
// });

// export const { setNotificationCount, setNotifications, setNotificationList, setActivityList } = notificationSlice.actions;
// export default notificationSlice.reducer;


const notificationSlice = createSlice({
  name: "notifications",
  initialState: {
    count: 0,
    hrCount: 0,
    expiryList: [],
    expiryListHR: [],
    activityListAll: [],
    activityListHR: [],
    attendanceListAll :[],
    loading: false,
  },
  reducers: {
    setNotificationCount: (state, action) => {
      state.count = action.payload;
    },
    setNotificationHrCount: (state, action) => {
      state.hrCount = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadAllNotifications.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadAllNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.expiryList = action.payload.expiryList;
        state.expiryListHR = action.payload.expiryListHR;
        state.activityListAll = action.payload.activityListAll;
        state.attendanceListAll = action.payload.attendanceList;
        state.activityListHR = action.payload.activityListHR;
        state.count = action.payload.count;
        state.hrCount = action.payload.hrCount;
      })
      .addCase(loadAllNotifications.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setNotificationCount } = notificationSlice.actions;
export default notificationSlice.reducer;
